import role from "@/http/requests/role"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      role.fetch().then(response => {
        commit('SET_ROLES', response.data.data.roles)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      role.infos(roleId).then(response => {
        commit('SET_ROLE_INFOS', response.data.data.roleInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      role.add(data).then(response => {
        commit('ADD_ROLE', response.data.data.createRole)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      role.update(data).then(response => {
        commit('UPDATE_ROLE', response.data.data.updateRole)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      role.delete(roleId).then(response => {
        commit('DELETE_ROLE', roleId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
